import React from "react";
import { Autocomplete } from "../search/autocomplete";
import { createQS } from "./../search/utils";

const GlobalSearch: React.FunctionComponent<any> = (): JSX.Element => {
  const onSubmitCallback = (state: any) => {
    window.location.assign(`/sok${createQS({ query: state.query, page: 1 })}`);
  };

  return <Autocomplete initialStateQuery={""} onSubmitCallback={onSubmitCallback} />;
};

export default GlobalSearch;
